import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { DataTableTypes } from 'inn-datatable';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis } from 'ng-apexcharts';
import { BehaviorSubject } from 'rxjs';
import { ReportCurrencyFormatter } from 'src/app/models/reportCurrencyFormatter';
import { CurrencyService } from 'src/app/services/currency.service';
import { DealsService } from 'src/app/services/deals.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { AppState } from 'src/app/store/app.state';
import DateUtils from 'src/app/utils/date';

export type ApexChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};

@Component({
  selector: 'app-time-to-win-deal',
  templateUrl: './time-to-win-deal.component.html',
  styleUrls: ['./time-to-win-deal.component.css']
})
export class TimeToWinDealComponent implements OnInit {
  id;
  type;
  payload;
  timeToWinChart;
  timeToWinData;
  loadingData;
  dateUtil = new DateUtils;
  dateType = '90';
  dateRange = { startDate: null, endDate: null };
  today = new Date().toISOString().slice(0, 10);
  selectedIds = null; selectedType = null;
  timeToWin = { start: this.today.slice(0, 8) + '01', end: this.today, };
  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title: "Client Name", key: "clientName" },
      { title: "Deal Name", key: "name" },
      { title: "Owner", key: "source" },
      { title: "Age (Days)", key: "age" },
      { title: "Amount", key: "amount" },
    ],
    options: <DataTableTypes.Options>{
      debug: false,
      emitClickActions: [],
      singleActions: [],
      noOfRowsToDisplay: 3
    }
  }
  public chartOptions: Partial<ApexChartOptions> = {
    series: [
      {
        name: "basic",
        data: [400, 430, 448, 470, 540]
      }
    ],
    chart: {
      type: "bar",
      height: 270
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: [],
    },
    colors: [
      "rgb(255,177,193))", "rgb(154,208,245)", "rgb(255,230,170)",
      "rgb(165,223,223)", "rgb(204,178,255)"
    ]
  };

  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
  ) {
    this.dateRange = this.dateUtil.getDefReportDateRange(Number(this.dateType));
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.handleDateFilter();
      }
    })
  }

  ngOnInit() {
    this.timeToWinChart = {
      series: [
        {
          name: "Time To Win",
          data: []
        }
      ],
      xaxis: {
        categories: []
      }
    }
    this.handleDateFilter();
  }
  dateChange({ dateRange, dateType }) {
    this.dateRange = dateRange;
    this.dateType = dateType;
    this.handleDateFilter();
  }

  handleDateFilter() {
    this.loadingData = false;
    this.getId();
    this.getTimeToWin();
  }

  getId() {
    // const { start, end } = this.timeToWin;
    const { startDate: start, endDate: end } = this.dateRange;
    let type = this.selectedType === "salesperson" ? 3 : this.selectedType === "team" ? 2 : null;
    this.payload = {
      startDate: start,
      endDate: end,
      id: this.selectedIds ? this.selectedIds.map(i => i.toString()) : null,
      type: type || 3
    };
  }

  getTimeToWin() {
    this.timeToWinData = null;
    this.dealSrv.fetchDealAgeStatistics(this.payload).subscribe((datas: any[]) => {
      const tableData = []
      const deals = datas.sort((a, b) => {
        if (a.age > b.age) {
          return 1
        } else {
          return -1
        }
      })
      deals.forEach((data) => {
        const { name, clientName, age, source, amount, currency } = data;
        const currencyF = new ReportCurrencyFormatter();
        tableData.push({
          name, clientName, age, source, amount: currencyF.handleFormatter(amount)
        })
      })
      this.timeToWinData = tableData;
      this.dataTable.dataChangedObs.next(true);
      this.loadingData = true;
    })
  }

}
